<div class="page__content">
    <div class="content__inner">
        <div class="content__login">
            <div class="card__login">
                <form *ngIf="!isSuccessful" name="form" (ngSubmit)="preSubmit() && form.valid && onSubmit()" [formGroup]="form">
                    <h1>{{ 'RESET.TITLE' | translate }}</h1>
                    <div class="form-group">
                        <input type="email " class="form-control" name="email "  formControlName="email" 
                            [placeholder]="'RESET.EMAIL_PH' | translate" />
                        <div class="alert-danger" *ngIf="form.controls['email']?.errors && form.controls['newPassword']?.touched">
                            <div *ngIf="form.controls['email']?.errors['required']">{{ 'RESET.EMAIL_REQUIRED' | translate }}</div>
                            <div *ngIf="form.controls['email']?.errors['email']">{{ 'RESET.EMAIL_INVALID' | translate }}</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" name="newPassword "  formControlName="newPassword"
                             minlength="6 "  
                             [placeholder]="'RESET.PASSWORD_PH' | translate" autocomplete="new-password"
                             [ngClass]="{'is-invalid': form?.controls && form.controls['newPassword']?.invalid && form.controls['newPassword']?.touched}"
                             />
                        <div class="alert-danger" role="alert " *ngIf="form.controls['newPassword'].errors && form.controls['newPassword']?.touched">
                            <div *ngIf="form.controls['newPassword']?.errors['required']">
                                {{ 'RESET.PASSWORD_REQUIRED' | translate }}
                            </div>
                            <div *ngIf="form.controls['newPassword']?.errors['minlength']">
                                {{ 'RESET.PASSWORD_MIN' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" name="newPasswordConfirm"  formControlName="newPasswordConfirmar"
                             [placeholder]="'RESET.CONFIRM_PH' | translate" autocomplete="new-password"
                             [ngClass]="{'is-invalid':form.controls['newPasswordConfirmar']?.invalid && form.controls['newPasswordConfirmar']?.touched}" />
                        <div class="alert-danger" role="alert " *ngIf="form.controls['newPasswordConfirmar']?.errors && form.controls['newPasswordConfirmar']?.touched">
                            <div *ngIf="form.controls['newPasswordConfirmar']?.errors['required']">
                                {{ 'RESET.PASSWORD_REQUIRED' | translate }}
                            </div>
                            <div *ngIf="form.controls['newPasswordConfirmar']?.errors['passwordMatchValidator']">
                                {{ 'RESET.PASSWORD_MATCH' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <!--
                        <button [disabled]="loading" class="btn btn-primary btn-block">
              <span
                *ngIf="loading"
                class="spinner-border spinner-border-sm mr-1"
              ></span>
              Restablecer contraseña
            </button>
            -->
                        <div class="form-group">
                            <button class="btn btn-primary btn-block" [disabled]="loading">
                                {{ 'RESET.SUBMIT' | translate }}
                            </button>
                        </div>
                    </div>
                    <div class="form-group">
                        <a routerLink="/login " class="forgot-password">{{ 'RESET.CANCEL' | translate }}</a>
                    </div>
                </form>
                <div class="alert alert-success" *ngIf="isSuccessful">
                    {{ 'RESET.SUCCESS' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
